import { useNavigate } from "react-router-dom";
import { IApp, IApps } from "../../../../models/master/apps";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { setApps } from "../../../../store/slices/master/appSlice";
import { getApps } from "../../../../action/masters/appActionCreator";
import { IHrAndBenefits } from "../../../../models/dashboard/staffDashboard";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const HrAndBenifit = (props: IHrAndBenefits) => {
  const { snapShots, getAllHrAndBenifits, HrAndBenifits } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(`${ROUTER_URL.RESOURCES}#resource-apps`);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.hrAndBenefits);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllHrAndBenifits(pageBlockId.hrAndBenefits, limit.four);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>HR & Benefits</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All HR & Benifits"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="row">
          {HrAndBenifits?.filter(
            (benifits: IApps) => benifits.displayOrNot
          ).map((benifits: IApps) => (
            <div className="col-lg-12" key={benifits.id}>
              <div className="btncard icon-visibility">
                <a href={benifits.url} target="_blank">
                  <img src={baseURL + benifits.image} alt={benifits.name} />
                  <h3>{benifits.name}</h3>
                  <span>
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllHrAndBenifits: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    HrAndBenifits: state.app.apps,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HrAndBenifit);
